var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail_box"},[_c('div',{staticClass:"detail_info",domProps:{"innerHTML":_vm._s(_vm.liveInfo.introductionHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }